// The public site's canonical origin, named once for the whole repository. The server imports it and is compiled
// with it into server-dist; the browser code imports it through src/lib/siteOrigin.ts; vite.config.ts writes it into
// index.html; the sitemap and SEO scripts import this file directly. Every build output (HTML, client bundle, sitemap,
// robots.txt) carries it, so it is a constant, never read from the environment: a runtime value could contradict them.
export const SITE_ORIGIN = "https://www.consultic.com";
